/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BaseComponent, CompoApiService, CrmIssue, FileService} from 'compob2b-libs';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged, startWith, tap} from 'rxjs/operators';
import {Executor, ExecutorAutocompleteStore} from '../executor-autocomplete.store';

@Component({
    selector: 'app-executor-autocomplete',
    templateUrl: './executor-autocomplete.component.html',
    styleUrls: ['./executor-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExecutorAutocompleteComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() issue: CrmIssue;
  @Output() selectedAssigneeEvent = new EventEmitter<Executor>();
  focusAssigneeInput = false;
  focusAssigneeButton = false;
  selectedAssignee: Executor;
  inputAssigneeControl: FormControl;
  @ViewChild('inputAssigneeElement') inputAssigneeElement: ElementRef;

  constructor(private readonly fileService: FileService,
              public readonly store: ExecutorAutocompleteStore) {
    super();
  }

  ngOnInit(): void {
    this.selectedAssignee = this.createExecutor(this.issue.assignee);
    this.inputAssigneeControl = new FormControl(this.selectedAssignee.header);
  }

  ngAfterViewInit(): void {
    this.store.load();

    this.inputAssigneeControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
        tap(keyword => this.store.filter(keyword))
      ).subscribe();
  }

  get emptyAssignee() {
    return {id: 0, header: 'Не назначено', picture: null};
  }

  get isEmptyAssignee(): boolean {
    return this.selectedAssignee.id === 0;
  }

  clearAssignee() {
    this.selectedAssignee = this.emptyAssignee;
    this.resetAndClose();
    this.onChangeAssignee(this.emptyAssignee);
  }

  showSearchAssignee() {
    this.store.reset();
    this.focusAssigneeInput = true;
    this.focusAssigneeButton = true;
  }

  blurAssignee($event) {
    // Был клик по выбору в AC, вызовется onChangeAssignee
    if ($event.relatedTarget && $event.relatedTarget.classList.contains('dont-reset')) {
      return;
    }

    this.resetAndClose();
  }

  onChangeAssignee(assignee: any) {
    if (typeof assignee === 'object') {
      this.selectedAssignee = assignee;
      this.resetAndClose();
      this.selectedAssigneeEvent.emit(assignee);
    }
  }

  resetAndClose() {
    this.inputAssigneeControl.setValue(this.selectedAssignee.header);
    this.inputAssigneeElement.nativeElement.selectionEnd = 0;
    this.focusAssigneeInput = false;
    this.focusAssigneeButton = false;
    this.cdr.detectChanges();
  }

  getImageSrc(picture: string): string {
    return picture === null ? null : this.fileService.getImageSrc(picture, 96);
  }

  private createExecutor(assignee: any) {
    return assignee ? {
      id: assignee.id,
      header: assignee.firstName + ' ' + assignee.lastName,
      picture: assignee.picture ? assignee.picture.name + '.' + assignee.picture.type : null
    } : this.emptyAssignee;
  }
}
